import {
  AtlasAdditionalPrompt,
  AtlasPromptLanguage
} from '@secca/shared/components/atlas-chatbot/additional-prompts-dialog/atlas-chatbot-additional-prompts-dialog.component';
import {
  getAtlasCsvCell,
  parseAtlasDelimitedRows
} from '@secca/shared/helpers/atlas/atlas-csv-parser.helper';

export function parseSuggestedPromptQuestionsCsv(csvText: string): AtlasAdditionalPrompt[] {
  const rows = parseAtlasDelimitedRows(csvText, ';');
  if (rows.length < 2) {
    return [];
  }

  const headers = rows[0].map(header => header.trim());
  const indexes = {
    category: headers.indexOf('category'),
    danish: headers.indexOf('question_danish'),
    norwegian: headers.indexOf('question_norwegian'),
    swedish: headers.indexOf('question_swedish'),
    finnish: headers.indexOf('question_finish'),
    english: headers.indexOf('question_english')
  };

  if (indexes.danish < 0) {
    return [];
  }

  return rows.slice(1)
    .map(row => {
      const danish = getAtlasCsvCell(row, indexes.danish);
      if (!danish) {
        return null;
      }

      const questions: Record<AtlasPromptLanguage, string> = {
        danish,
        norwegian: getAtlasCsvCell(row, indexes.norwegian) || danish,
        swedish: getAtlasCsvCell(row, indexes.swedish) || danish,
        finnish: getAtlasCsvCell(row, indexes.finnish) || danish,
        english: getAtlasCsvCell(row, indexes.english) || danish
      };

      return {
        category: getAtlasCsvCell(row, indexes.category) || 'General',
        title: danish,
        questions
      };
    })
    .filter((prompt): prompt is AtlasAdditionalPrompt => Boolean(prompt));
}
